export default "__VITE_ASSET__dvJc6Zyr__"